__webpack_require__.p = "/qplayer/";